export default {
  status: {
    notes: 'Name of field "status" for order line',
    message: 'Status',
  },
  deliveredDate: {
    notes: 'Name of field "delivered" for order line',
    message: 'Delivered',
  },
  quantity: {
    notes: 'Name of field "quantity" for order line',
    message: 'Quantity',
  },
  taggedTo: {
    notes: 'Name of field "taggedTo" for order line',
    message: 'Tagged to',
  },
  weight: {
    notes: 'Name of field "weight" for order line',
    message: 'Weight',
  },
  price: {
    notes: 'Name of field "Net price" for order line',
    message: 'Net price',
  },
  lineTotal: {
    notes: 'Name of field "line total" for order line',
    message: 'Line total',
  },
  shipmentReference: {
    notes: 'Name of field "shipment reference" for order line',
    message: 'Shipment reference',
  },
  shippedDate: {
    notes: 'Name of field "shipped date" for order line',
    message: 'Shipped',
  },
  deliveryExpected: {
    notes: 'Name of field "Delivery expected date" for order line',
    message: 'Delivery expected',
  },
  qtyDelivered: {
    notes: 'Name of field "quantity delivered" for order line',
    message: 'Quantity delivered',
  },
  consignee: {
    notes: 'Name of field "consignee" for order line',
    message: 'Consignee',
  },
  invoiceNumber: {
    notes: 'Name of field "invoiceNumber" for order line',
    message: 'Invoice',
  },
  addToCart: {
    notes: 'Column name for action Add to cart (used in column selector)',
    message: 'Add to cart',
  },
  stockStandard: {
    notes: 'Name of field "Stock standard" for order line',
    message: 'Stock standard',
  },
};
